import React from 'react';
import { Icon } from '@chargify/icons';

import { BodyText, Column, Row, Tooltip } from '../../../atoms';
import { NameWrapper } from './MeteredComponent.styles';
import { MeteredProps } from './types';

const MeteredComponent = ({ name, description, value }: MeteredProps) => (
  <Row>
    <Column span={12}>
      <NameWrapper gridColumnGap={2}>
        <BodyText
          variant="body2"
          color="gray.dark"
          fontWeight={2}
          overflow="truncate"
        >
          {name}
        </BodyText>
        {description && (
          <Tooltip
            renderContent={() => <Tooltip.Text message={description} />}
            placement="top-start"
            followCursor
          >
            <Icon type="questionCircle" size={16} fill="gray.dark" />
          </Tooltip>
        )}
      </NameWrapper>
    </Column>
    <Column span={12}>
      <BodyText variant="body2" color="black.main" textAlign="right">
        {value}
      </BodyText>
    </Column>
  </Row>
);

export default MeteredComponent;
